import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { rootRoute } from '@/user/root'

export const profileRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/profile',
    component: lazyRouteComponent(() => import('./Profile'), 'Profile'),
})
